export default __webpack_public_path__ + "static/home_video-113036b5e5c90ca81d2a4512796e0d1d.webp";